import { withPrefix } from 'gatsby'
import { getDebugLogger } from '../utils/logger'

const debug = getDebugLogger('RouteChangePubSub')

type IRouteHandler = (newPath: string, oldPath?: string) => void

const routeSubscribers = new Map<string, Set<IRouteHandler>>()
const anySubscribers = new Set<IRouteHandler>()

export function matchRoutes(current: string, target: string) {
  return (current === target || current === target + '/'
    || current === withPrefix(target) || current === withPrefix(target) + '/')
}

export function subscribe(route: string, handler: IRouteHandler) {
  const prefixedRoute = withPrefix(route)
  debug('subscribe', { route, prefixedRoute })
  if (!routeSubscribers.has(prefixedRoute)) {
    routeSubscribers.set(prefixedRoute, new Set())
  }
  const slice = routeSubscribers.get(prefixedRoute)
  slice!.add(handler)
}

export function subscribeAny(handler: IRouteHandler) {
  debug('subscribeAny')
  anySubscribers.add(handler)
}

export function unsubscribe(route: string, handler: IRouteHandler) {
  debug('unsubscribe', { route })
  if (routeSubscribers.has(route)) {
    const slice = routeSubscribers.get(route)
    slice!.delete(handler)
  }
}

export function unsubscribeAny(handler: IRouteHandler) {
  debug('unsubscribeAny')
  anySubscribers.delete(handler)
}

export function publish(newPath: string, oldPath?: string) {
  debug('publish', { newPath, oldPath, anySubscribers, routeSubscribers })

  for (const anySubscriber of anySubscribers) {
    setTimeout(() => {
      anySubscriber(newPath, oldPath)
    })
  }

  if (routeSubscribers.has(newPath)) {
    const routeSlice = routeSubscribers.get(newPath)
    for (const routeSubscriber of routeSlice!) {
      setTimeout(() => {
        routeSubscriber(newPath, oldPath)
      }, 0)
    }
  }
}
